import React, { useState, useEffect } from "react";
import s from "./keywords.module.scss";
import { InputCheckBox, InputText, TextArea } from "commons/input-controls";
import { StandartButton } from "commons/form-controls";
import {ReactComponent as PlusIcon} from "assets/icons/plus.svg";
import {ReactComponent as CloseIcon} from "assets/icons/close.svg";
import {ReactComponent as SaveIcon} from "assets/icons/save.svg";
import { ReactComponent as OpenInIcon } from 'assets/icons/open-in.svg';
import CheckArchiveContainer from "./check-archive/check-archive-container";
import MessageTextContainer from "./message-text/message-text-container";
import { setSelectAllItems } from "store/storage";

const Keywords = (props) => {

    const [keyword, setKeyword] = useState('');
    const linkRegExp = /(https?:\/\/)?([\w-]+\.)+\w+\/.+?/

    const oneSymbolwithStar = /(\s\S\*)|(^\S\*)/
    const noAmpersands = /(\S&&)|(&&\S)|(^&&)|(&&(\s+)?$)/
    const noStarOnStartOrEnd = /(\*\S)|([^\p{L}\d]\*)/
    const starsOnCenterOrEnd = /(\s\*)|(^\*)|([^\p{L}\d]\*)/gu
    const noCharachters = /[:;!,%()\/\\@]/
    const threeAmpersands = /&{3,}/
    const singleStar = /(\s|^)[*?]+(\s|$)/
    const noPlusMinusOnAfter = /[+-]$/;
    //(^\*)|
    /*/(\*\S)|([^\p{L}\d]\*)&{3,}/*/
    const [keys, setKeys] = useState(props.keywords)
    const [message, setMessage] = useState('');
    const [rows, setRows] = useState(1);
    const [resize, setResize] = useState(false);
    const [pasteKeywords, setPasteKeywords] = useState(null);
    const [reRender, setRerender] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)
    const [searchText, setSearchText] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [isSelectedAllItems, setIsSelectedAllItems] = useState(false);

    const setMessageError = (error) => {
        setTimeout(() => {setErrorMessage(error); setRerender(!reRender)}, 500);
        
    }

    const checkKeyWords = (keyword) => {
            if(keyword.match(singleStar)){
                setMessageError(props.getValue('SINGLE_STAR'));
                return true;
            }
            else if(keyword.match(starsOnCenterOrEnd)){
                setMessageError(props.getValue('STARS_ON_CENTER_OR_END'));
                return true;
            }
            else if(keyword.match(threeAmpersands)){
                setMessageError(props.getValue('THREE_AMPERSANDS'));
                return true;
            }
            else if(keyword.match(noAmpersands)){
                setMessageError(props.getValue('NO_AMPERSANDS'));
                return true;
            }
            else if(keyword.match(oneSymbolwithStar)){
                setMessageError(props.getValue('ONE_SYMBOL_WITH_STAR'));
                return true;
            }
            else if(keyword.match(noCharachters)){
                setMessageError(props.getValue('NO_CHARACHTERS'));
                return true;
            }
            else if(keyword.match(noPlusMinusOnAfter)){
                setMessageError(props.getValue('NO_PLUS_AND_MINUS_ON_AFTER'));
                return true;
            }
            else{
                setMessageError(null)
                return false;
            }
        
    }

    const checkLink = (link, type) => {
        switch(type){
            case 'socnetProfiles':
                return !link || link && link.match(linkRegExp) ? true : false;
            case 'resources':
                let res = props.domains.filter(k => k.name === link);
                return res.length ? false : true;
            case 'keywords':
            case 'stopwords':
                if(!link || link === ''){
                    setMessageError(null)
                    return false
                }
                return !link || link && !checkKeyWords(link) ? true : false;
                //return ks
        }

    }

    let getByType = (type) => {
        switch(type){
            case 'keywords':
                return props.keywords;
            case 'stopwords':
                return props.stopwords;
            case 'socnetProfiles':
                return props.profiles;
            case 'resources':
                return props.resources;
            default:
                return props.keywords
        }
    }

    const [keywords, setKeywordsByType] = useState(getByType(props.type));

    useEffect(() => {
        setKeywordsByType(getByType(props.type));
        //setKeys(props.keywords);
        //setRerender(!reRender)
        //if(props.showOnly)
        //    setPasteKeywords(null)
        //setMessage(props.getValue(props.message));
    }, [props.type, props.keywords, props.stopwords, props.profiles, props.resources]);

    const changePasteKeywordsItems = (item, index, e) => {
        let keyList = pasteKeywords;
        if(keyList[index]){
            keyList[index] = e.target.value;
        }

        setPasteKeywords(keyList)
        setRerender(!reRender)
    }

    const onPasteText = (e) => {
        let pasteKeywords = e && e.length ? e.split('\n') : [];
        let keyList = []
        if(Array.isArray(pasteKeywords) && pasteKeywords.length > 1){
            pasteKeywords.forEach((k, i) => {
                if(k && k.length){

                    keyList.push(k)
                }
                 
            })
            setPasteKeywords(keyList)
        }

    }

    const newKeyWord = (keyword) => {
        keyword = keyword.trim()
        //if(keyword !== '' && keyword !== ' '){
            
            setKeyword(keyword)
            if(!keyword || keyword === '') checkLink(keyword, props.type)
            setResize(!resize);

        //}
    }

    const goto = (e) => {
        addKeyword(e)
    }

    const addKeyword = (value) => {
        let keys = pasteKeywords//keyword.split('\n')
        if(keys && keys.length){

            keys.forEach(k => {
                if(k && k.length && k !== ''){
                    props.setItemByType(props.type, k.trim())
                }
            })
        }
        else{
            if(checkLink(keyword, props.type)){
                props.setItemByType(props.type, keyword)
            }
            else{
                setTimeout(() => {setKeyword(keyword)}, 20) 
                return
            }
            
        }

        if(pasteKeywords){
            setPasteKeywords(null)
        }
        setKeyword('');
        setRerender(!reRender)
    }

    const getValueByType = (type) => {
        switch(type){
            case 'socnetProfiles':
                return 'url'
            case 'resources':
                return 'domain'
            default:
                return 'keyword'
        }
    }

    const deleteKeyword = (value) => {
        props.removeItemByType(props.type, value[getValueByType(props.type)])
        setRerender(!reRender)
    }

    const getItemByType = (type) => {
        switch(type){
            case 'socnetProfiles':
                return 'url'
            case 'resources':
                return 'domain'
            default:
                return 'keyword'
        }
    }

    const selectToCopy = (selected, it, ki) => {
        let items = selectedItems;
        let f = items.indexOf(selected)
        if( f === -1){
            items.push(selected);
        }
        else{
            items.splice(f, 1);
        }
        setSelectedItems(items)
        setRerender(!reRender)
    }

    const selectAllToCopy = (isSelected) => {
        let items = [];
        if(isSelected){
            if(searchText !== ''){
                items = keywords.filter(k => k[getItemByType(props.type)].toLowerCase().indexOf(searchText.toLowerCase()) !== -1).map(k => k[getItemByType(props.type)]);
            }
            else 
                items = keywords.map(k => k[getItemByType(props.type)]);
        }
        setIsSelectedAllItems(isSelected)
        setSelectedItems(items);
        setRerender(!reRender);
    }

    const drawTabel = (k, i) => {
        let name = k[getItemByType(props.type)];
        return <tr key={i}>
            <td>{i+1}</td>
            {props.BigWindow ? <td><InputCheckBox title={name} isChecked={selectedItems.indexOf(name) != -1} callback={selectToCopy.bind(this, name)} name={name+" "+i}/></td> : null}
            <td>{name}</td>
            {!props.showOnly ? <td><button onClick={deleteKeyword.bind(this, k)} className={s.deleteKeyword}><CloseIcon /></button></td> : null}
        </tr>
    }

    const checkItem = () => {
        props.check(keyword)
    }

    const setTextMessage = (message) => {
        setMessage(message);
    }

    const getTitleByType = (type) => {
        switch(type){
            case 'keywords':
                return props.getValue('KEYWORDS');
            case 'stopwords':
                return props.getValue('STOPWORDS');;
            case 'socnetProfiles':
                return props.getValue('PROFILES');;
            case 'resources':
                return props.getValue('RESOURCES');;
            default:
                return props.getValue('WORDS');
        }
    }

    const keyUp = (index, key) => {
        if(key.key === 'Enter'){
            let pkeywords = pasteKeywords;
            let keys = key.target.value.split('\n');
            keys.forEach((k, i) => {
                if(k && k.length){
                    if(i === 0 )
                        pkeywords.splice(index, 1, k)
                    else 
                        pkeywords.splice(index+i, 0, k)
                }
            })

            setPasteKeywords(pkeywords)
            setRerender(!reRender)
        }
    }

    const openIn = () => {
        setSelectedItems(null);
        props.openKeywords();
    }

    const copyToClipboard = () => {
        let str = selectedItems.join('\n ');
        navigator.clipboard.writeText(str);
        setIsSelectedAllItems(false);
        setSelectedItems([]);
    }

    const filterKeywords = (text) => {
        setSelectedItems([]);
        setIsSelectedAllItems(false)
        setSearchText(text)
    }

    const pasteKeywordsList = pasteKeywords && pasteKeywords.length 
            ? pasteKeywords.map((k,i) => {
                let checked = checkLink(k, props.type)
                return <textarea key={i} onKeyUp={keyUp.bind(this, i)} className={checked ? s.checkedInput : s.nonCheckedInput} onChange={changePasteKeywordsItems.bind(this, k, i)} value={k}/>
            })
            : []

    let items = getByType(props.type);

    let tableItems = []

    if(props.type === 'keywords' || props.type === 'stopwords'){
        items && items.length ? items.forEach((k, i) => {
            let f = k.keyword.toLowerCase();
            searchText !== '' ? f.indexOf(searchText.toLowerCase()) !== -1 ? tableItems.push(drawTabel(k,i)) : null
                        : tableItems.push(drawTabel(k,i))
        }) : null
    }
    else tableItems = items.map((k, i) => drawTabel(k, i))

    return (
        <div className={props.BigWindow && props.BigWindow !== undefined ? s.Keywords + ' '+s.BigWindow : s.Keywords}>
            <div className={s.KeywordsHeader}>{!props.showOnly ? <div className={s.Row}>
                {(pasteKeywords && pasteKeywords.length > 1) ? <div className={s.pasteKeywords}>
                                    {pasteKeywordsList}
                                </div>
                                : (props.type === 'keywords' || props.type === 'stopwords') 
                                                                                        ? <TextArea onPasteText={onPasteText} resize={false} rows={rows} title={props.title ? props.title : null} placeholder={props.type === 'socnetProfiles' ? 'example.com/value' : props.getValue('ENTER_NEW_WORD')} callback={newKeyWord} value={keyword} goto={addKeyword} />
                                                                                        : <InputText resize={false} rows={rows} title={props.title ? props.title : null} placeholder={props.type === 'socnetProfiles' ? 'example.com/value' : props.getValue('ENTER_NEW_WORD')} callback={newKeyWord} value={keyword} />
                }
                {props.type === 'socnetProfiles' || props.type === 'resources'
                    ? <CheckArchiveContainer type={props.type} resource={keyword} isDisabled={(keyword && !message) ? false : true} setTextMessage={setTextMessage}/>//<StandartButton disabled={(keyword && !message) ? false : true} icon={SearchIcon} callback={checkItem} fill={'white'}/>
                    : null
                }
                <StandartButton disabled={(!keyword || keyword === '') || (props.reg ? !checkLink(pasteKeywords && pasteKeywords.length > 1 ? pasteKeywords.join(' ') : keyword, props.type) : false)} name={props.getValue('ADD')} icon={PlusIcon} fill="white" callback={addKeyword}/>
            </div> : null }
            {props.BigWindow && props.BigWindow !== undefined 
                                                                ?   <div>
                                                                        <InputText value={searchText} placeholder={props.getValue('SEARCH_BY_TITLE')} callback={filterKeywords}/>
                                                                    </div> 
                                                                : null}
            </div>
            { props.type === 'socnetProfiles' ? <MessageTextContainer type={props.type}/> : null}
            { props.type === 'resources' ? <MessageTextContainer type={props.type}/> : null}
            { props.type === 'keywords' || props.type === 'stopwords' && errorMessage ? <div className={s.errorMessage}>{errorMessage}</div> : null}
            <div className={s.KeywordsList}>
                    <table>
                        <thead>
                            <tr>
                                <th>№</th>
                                {props.BigWindow && props.BigWindow !== undefined ? <th><InputCheckBox title={props.getValue('CHOOSE_ALL')} isChecked={isSelectedAllItems} callback={selectAllToCopy} name={'selectAllItems'} /></th> : null}
                                <th>{getTitleByType(props.type)}</th>
                                {props.openKeywords ? <th><StandartButton callback={openIn} name={props.getValue('FULL_LIST')} width={22} height={22} stroke={'white'} icon={OpenInIcon}/></th> : <th></th>}
                            </tr>
                        </thead>
                    </table>
                    <div className={keywords && keywords.length > 4 ? s.keywordsBody+' '+s.scrollBody : s.keywordsBody}>
                        <table>
                            <tbody>
                                {tableItems}
                            </tbody>
                        </table>
                    </div>

                
            </div>
            {props.BigWindow ? <div className={s.copyToClipboard}>
                <StandartButton name={props.getValue('COPY_TO_CLIPBOARD')} disabled={!selectedItems || !selectedItems.length} fill={'white'} callback={copyToClipboard} icon={SaveIcon} />
            </div> : null}

        </div>
    )
}

export default Keywords

//link.match(oneSymbolwithStar+'|'+noAmpersands+'|'+starsOnStartCenterOrEnd+'|'+noCharachters+'|'+threeAmpersands+'|'+singleStar) === null)